/**
 * Template Formatting Utilities
 * Functions for text formatting operations
 */

/**
 * Insert formatting markers around selected text
 */
export const applyFormatting = (text, selectedText, format) => {
  const formatMap = {
    bold: { prefix: "*", suffix: "*" },
    italic: { prefix: "_", suffix: "_" },
    strikethrough: { prefix: "~", suffix: "~" },
  };

  const formatStyle = formatMap[format];
  if (!formatStyle) return selectedText;

  return `${formatStyle.prefix}${selectedText}${formatStyle.suffix}`;
};

/**
 * Insert variable at cursor position
 */
export const insertVariableAtPosition = (text, cursorPosition, variableNumber) => {
  const variableText = `{{${variableNumber}}}`;
  return (
    text.slice(0, cursorPosition) +
    variableText +
    text.slice(cursorPosition)
  );
};

/**
 * Remove variable from text
 */
export const removeVariableFromText = (text, variableNumber) => {
  const regex = new RegExp(`\\{\\{${variableNumber}\\}\\}`, "g");
  return text.replace(regex, "");
};

